<div class="astral-stack-l">
  <h5>{{ 'COMPANY.SETTINGS_GL07' | translate }}</h5>

  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <astral-input [control]="form.controls['fileExtension']"></astral-input>
    <astral-select [control]="form.controls['encodingName']" [itemsSource]="encodingSelection"></astral-select>
    <astral-checkbox [control]="form.controls['bundleFile']"></astral-checkbox>
    <astral-checkbox [control]="form.controls['asymmetricBundling']"></astral-checkbox>
    <astral-checkbox [control]="form.controls['includeTodaysWork']"></astral-checkbox>
    <astral-input [control]="form.controls['interface']"></astral-input>
    <astral-input [control]="form.controls['voucherType']"></astral-input>
    <astral-input [control]="form.controls['client']"></astral-input>
    <astral-input [control]="form.controls['taxCode']"></astral-input>
    <astral-input [control]="form.controls['ledgerType']"></astral-input>
    <astral-select [control]="form.controls['customerOrSupplierIdDim']" [itemsSource]="customerOrSupplierIdDimSelection"></astral-select>
    @if (form.controls['customerOrSupplierIdDim'].value == 99) {
      <astral-input
        [control]="form.controls['customerOrSupplierIdDimFixed']"
      ></astral-input>
    }
    @if (!form.controls['bundleFile'].value) {
      <astral-select
        [control]="form.controls['invoiceReference']"
        [itemsSource]="invoiceReferenceSelection"
      ></astral-select>
    }

    @for (field of [
      ['dim1', 'd1Fixed'],
      ['dim2', 'd2Fixed'],
      ['dim3', 'd3Fixed'],
      ['dim4', 'd4Fixed'],
      ['dim5', 'd5Fixed'],
      ['dim6', 'd6Fixed'],
      ['dim7', 'd7Fixed']
      ]; track field) {
      <astral-select [control]="form.controls[field[0]]" [itemsSource]="dimensionSelection"></astral-select>
      @if (form.controls[field[0]].value == 99) {
        <astral-input [control]="form.controls[field[1]]"></astral-input>
      }
    }
  </astral-layout-group>
</div>
